import React, { HTMLAttributes, useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import './index.less';
import { ImageLayer } from '@meitu/saas-editor-core/es/layers/image-layer';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    opacity: number;
    onOpacity?: (opacity: number) => void;
}
const OpacityInspector: React.FC<IProps> = ({ id, opacity, onOpacity }) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();
    const originOpacity = useRef<number | null>(opacity);

    return (
        <div className="c-base-toolbar-controller c-base-toolbar-controller-vertical">
            <SliderInput
                title={$t((v) => v.panel.imagePanel.opacity)}
                value={parseInt(`${(opacity || 0) * 100}`)}
                showStepBtn={true}
                max={100}
                min={0}
                type="vertical"
                onChange={(val: number) => {
                    if (originOpacity.current === null) {
                        originOpacity.current = opacity;
                    }
                    editor.getInstance(ImageLayer).setOpacity(id, val / 100);
                }}
                onAfterChange={(val: number) => {
                    editor.getInstance(ImageLayer).setOpacity(id, val / 100);
                    originOpacity.current = null;
                    onOpacity?.(val / 100);
                }}
            />
        </div>
    );
};
export default React.memo(OpacityInspector);
